import { Box, Button, Colors } from 'basic-ui-lib';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch } from 'store/hooks';
import { useEffect } from 'react';
import storeActions from 'modules/store/services/actions';
import FormStore from './FormStore';
import { Form } from 'antd';
import { BusinessType } from 'modules/store/services/constants';

export interface FormStoreValues {
  firstName: string;
  lastName: string;
  businessName: string;
  phone: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  timezone?: string;
  businessType?: BusinessType;
}

const CreateOrUpdateStoreMobile = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm<FormStoreValues>();

  useEffect(() => {
    dispatch(storeActions.getListTimezones.fetch());
  }, []);

  return (
    <Container>
      <HeaderMobile title={id ? 'Edit Store' : 'New Store'} />
      <Content>
        <FormStore form={form} />
      </Content>
      <FooterMobileV2>
        <Button type_second lg type='submit' onClick={() => form.submit()}>
          OK
        </Button>
      </FooterMobileV2>
    </Container>
  );
};

export default CreateOrUpdateStoreMobile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  justify-content: space-between;
  overflow: hidden;
`;

const FooterMobileV2 = styled(Box)`
  display: flex;
  gap: 16px;
  background-color: ${Colors.neutral.bg[1]};
  left: 0;
  bottom: 0;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);
  padding: 16px;
  width: 100%;

  button {
    flex: 1;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

const Content = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  .form-styled {
    .ant-form-item {
      margin-bottom: 16px;
    }

    .ant-form-item-label > label {
      font-weight: 400;
      color: ${Colors.neutral.text[5]};
    }
  }
`;
